import { truncate } from 'lodash'

import { BodySubtext } from '@/components/atomic/text'
import Tooltip from '@/components/atomic/tooltip'
import { cn } from '@/utils/shadcn/utils'

const TEXT_MAX_LENGTH = {
  DEFAULT: 18,
}

interface TruncatedTextCellProps {
  text: string
  maxLength?: number
  className?: string
  tooltipClassName?: string
  wrapper?: React.ComponentType<{ children: React.ReactNode }>
}

export function TruncatedTextCell({
  text,
  maxLength = TEXT_MAX_LENGTH.DEFAULT,
  className,
  tooltipClassName = 'max-w-sm',
  wrapper: Wrapper = BodySubtext,
}: TruncatedTextCellProps) {
  if (!text) return null

  const isTruncated = text.length > maxLength
  const displayText = truncate(text, { length: maxLength })

  const content = <Wrapper>{displayText}</Wrapper>

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Tooltip
        simpleText={isTruncated ? text : undefined}
        className={tooltipClassName}
      >
        {content}
      </Tooltip>
    </div>
  )
}

interface AutoTruncatedTextCellProps {
  text: string
  className?: string
  tooltipClassName?: string
  wrapper?: React.ComponentType<{
    children: React.ReactNode
    className?: string
  }>
  textClassName?: string
  tooltipMaxWidth?: string | number
}

// Automatically truncates text using CSS line-clamp
export function AutoTruncatedTextCell({
  text,
  className,
  tooltipClassName = 'max-w-sm',
  wrapper: Wrapper = BodySubtext,
  textClassName = 'line-clamp-2',
  tooltipMaxWidth = '200px',
}: AutoTruncatedTextCellProps) {
  if (!text) return null

  return (
    <div
      className={cn(
        'flex items-center gap-2 h-full overflow-hidden',
        className,
      )}
    >
      <Tooltip
        simpleText={text}
        className={tooltipClassName}
        maxWidth={tooltipMaxWidth}
      >
        <Wrapper className={textClassName}>{text}</Wrapper>
      </Tooltip>
    </div>
  )
}
